import { Title } from "@gamesheet/ui";
import * as Grid from "../layouts/GridItems";

export function TeamSettingsPage(){
    return (<>
        <Grid.Blank column={1} row={1}>
            <Title bartype="divider" text="Team Settings" size="h2"/>
        </Grid.Blank>
    </>)
}